import { useEffect, useState } from "react";
import axios from "../helpers/axios";

export const createNewCustomer = async (values, callback) => {
  const res = await axios.post(`/customer/createcustomer`, values);

  if (res.status === 200) {
    callback(res.data.response);
  } else {
    callback(res.data.response);
  }
};

export const updateCustomer = async (id, values, callback) => {
  const res = await axios.put(`/customer/updatecustomer/${id}`, values);

  if (res.status === 200) {
    callback(res.data.response);
  } else {
    callback(res.data.response);
  }
};

export const deleteCustomer = async (id, value, callback) => {
  const res = await axios.put(`/customer/deletecustomer/${id}`, { updatedBy: value });

  if (res.status === 200) {
    callback(res.data.response);
  } else {
    callback(res.data.response);
  }
};

export const getAllCustomers = async (rowPerPage, pageNumber, search, callback) => {
  const res = await axios.get(`/customer/?rowPerPage=${rowPerPage}&pageNumber=${pageNumber}&search=${search}`);
  if (res.status === 200) {
    const customerList = res.data.response.data;
    callback(customerList);
  } else {
    callback(res.data.response);
  }
};

export const getCustomerById = async (id, callback) => {
  await axios.get(`/customer/${id}`).then((res) => {
    if (res.status === 200) {
      callback(res.data.response.data);
    } else {
      callback(res.data.response.data);
    }
  });
};

export const getCustomers = async (callback) => {
  await axios.get(`/customer/allcustomers`).then((res) => {
    if (res.status === 200) {
      callback(res.data.response.data);
    } else {
      callback(res.data.response.data);
    }
  });
};

export const CustomerAPI = () => {
  const [customers, setCustomers] = useState([]);
  const [allCustomers, setAllCustomers] = useState([]);
  const [customerDetail, setCustomerDetail] = useState({});

  const [rowPerPage, setRowPerPage] = useState(10);
  const [search, setSearch] = useState("");
  const [pageNumber, setPageNumber] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [callback, setCallback] = useState(false);
  const [id, setId] = useState(0);

  useEffect(() => {
    getAllCustomers(rowPerPage, pageNumber, search, (res) => {
      setCustomers(res);
      setTotalPages(res.totalPage || 1);
    });

    getCustomerById(id, (res) => {
      setCustomerDetail(res);
    });

    getCustomers((res) => {
      setAllCustomers(res);
    });
  }, [callback, rowPerPage, search, pageNumber, id]);

  return {
    customers: [customers, setCustomers],
    allCustomers: [allCustomers, setAllCustomers],
    customerDetail: [customerDetail, setCustomerDetail],
    id: [id, setId],
    rowPerPage: [rowPerPage, setRowPerPage],
    search: [setSearch],
    pageNumber: [pageNumber, setPageNumber],
    totalPages: [totalPages, setTotalPages],
    callback: [callback, setCallback],
  };
};
